"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findItem = void 0;
/**
 * Used to find object
 * @param {Array} arr
 * @param {String} key
 * @param {String} matchValue
 * @returns {EventLocale}
 */
var findItem = function (arr, key, matchValue, splitString) {
    if (splitString === void 0) { splitString = false; }
    return splitString
        ? arr.find(function (item) { return item[key].split('-')[0].toLowerCase() === matchValue; })
        : arr.find(function (item) { return item[key].toLowerCase() === matchValue; });
};
exports.findItem = findItem;
